import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";

import 'katex/dist/katex.min.css';

export default function GenericTemplate({data}) {
  const { markdownRemark } = data; // data.markdownRemark holds our post data
  const { frontmatter, parent, html } = markdownRemark;

  return (
    <Layout currentPage={frontmatter} modified={parent.modifiedTime}>
      <div>
            <h1>{ frontmatter.title }</h1>
            <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        name
      }
      parent {
        ... on File {
          id
          name
          modifiedTime(formatString: "MMM D YYYY HH:mm")
        }
      }
    }
  }`